<div
	#el
	class="ellipsis"
	[style.text-decoration]="selectable ? 'underline':''"
	(mouseenter)="onMouseEnter(el)"
	(mouseleave)="onMouseLeave(el)">
	<ng-content></ng-content>
</div>
